<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";
import NoImageUrl from "@/assets/no-image.png";

export default {
	components: {
		Layout
	},

	data () {
		return {
			NoImageUrl,
			publicPath: process.env.BASE_URL,
			style: null,
			restaurant: [],

			restaurant_id: '1',
			branch_id: '11',
			// token:'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJmQTVlS2hsMlROaUczdkd4WHZNU2NnIiwiaWQiOiIxODEifQ.L4hWfCo1HWRBaKa94MWL0GeJXWWPSk9U8Z8uDZgnY48',
			// device_token:'',
			// uid:'add7685f3ae21879',
			token:'',
			device_token:'',
			uid:'',
			guest_id:'',

			show_visible:false,
			search_visible: false,
			searchs: [],
			res_product_id:'',
			types: [],
			best_selling: [],
			categories:[],
			rating:{},
			reviews:[],
			order_rate:'',
			order_rate_pending:'',
			food_quality_rate:'',
			food_quality_rate_pending:'',
			delivery_time_rate:'',
			delivery_time_rate_pending:'',
			value_for_money_rate:'',
			value_for_money_rate_pending:'',
			res_product:'',
			key:'',
			choices:'',
			i:1,
			total_price:'',
			size:'',
			inputs: [
				{
					product_id: '',
					price_id: '',
					choiceproduct:[]
				},
         	],
			 ovalues:[],
			 checkbox_values:[],
			 price:'',
			 arranged_choices:[],
			 location:{},
			 notes:'',
			 arranged_choice_prices:[],
			 total_price_show:'',
			 toast:'',

			 size_unfilled: false,
			 choice_unfilled: false,
			 choice_errors: [],
		}
	},
	created() {
		this.style = document.createElement('link')
		this.style.setAttribute('rel', 'stylesheet')
		this.style.setAttribute('href', '/design/dairyqueen.css')
		document.head.appendChild(this.style)
		this.getToken();
	},

	beforeDestroy() {
		document.head.removeChild(this.style);
	},
	
	mounted() {
      this.fetchRestaurant();
		this.fetchRatings();
		this.getLocation();
   },
	methods: {
		getLocation() {
			if(localStorage.getItem('sigofood_location')) {
				console.log(localStorage.getItem('sigofood_location'));
				this.location = localStorage.getItem('sigofood_location');
			} else {
				this.$router.push({ name: "location" });
			}
		}, 
		getToken() {
			if (localStorage.getItem('sigofood_user')) {
				var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
				console.log(sigofood_user);
				if(sigofood_user.token) {
					this.token = sigofood_user.token;
					this.uid = sigofood_user.uid;
					this.user_id = sigofood_user.user_id;
					console.log(this.token);
					console.log(this.uid);
					console.log(this.user_id);

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
				
			} else if(localStorage.getItem('sigofood_guest')){
				var sigofood_guest =  JSON.parse(localStorage.getItem('sigofood_guest'));
				console.log(sigofood_guest);
				if(sigofood_guest.token) {
					this.token = sigofood_guest.token;
					this.device_token = sigofood_guest.token;
					this.guest_id = sigofood_guest.guest_id;
					console.log(this.device_token);
					console.log(this.guest_id);
					

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
      }, 

		fetchRestaurant() {

			const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,

               },
         };
         let url = "restaurant/details";          
			let formData = new FormData();
         formData.append("restaurant_id",this.$route.params.id);
         formData.append("branch_id", this.$route.params.branch_id );
			formData.append("latitude", this.location.latitude);
         formData.append("longitude", this.location.longitude);

         this.$axios
        	.post(url,formData, config)
         .then((res) => {
            if(res.status == 200) {
               var responseData = res.data.data;
               console.log(responseData);
					if(responseData.restaurant){
						this.restaurant = responseData.restaurant;
						console.log(this.restaurant);
						if(responseData.restaurant.types.length){
							this.types = responseData.restaurant.types;
						}
						if(responseData.best_selling.products.length){
							this.best_selling = responseData.best_selling.products;
							console.log(this.best_selling);
						}
						if(responseData.category.length){
							this.categories = responseData.category;
							console.log(this.categories);
						}
					}
            } else {
               this.$swal("", "Something went wrong", "error");
            }
                  
         })
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                        
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                        
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
      },
			
		fetchRatings(){
				
			// this.getToken();
         let url = "rating/getRatings?restaurant_id=" + this.$route.params.id;

         this.loading = true;
            
         this.$axios
         .get(url, { headers: { Authorization:this.token } })
         .then((res) => {
           	if(res.status == 200) {
               var responseData1 = res.data.data;
               console.log(responseData1);
					this.rating = responseData1;
					this.reviews = responseData1.total_reviews;
					this.order_rate = Math.floor(this.rating.order_pacaking_rating);
					this.order_rate_pending = 5-this.order_rate;
					this.food_quality_rate = Math.floor(this.rating.food_quality_rating);
					this.food_quality_rate_pending = 5-this.food_quality_rate;
					this.delivery_time_rate = Math.floor(this.rating.delivery_time_rating);
					this.delivery_time_rate_pending = 5-this.delivery_time_rate;
					this.value_for_money_rate = Math.floor(this.rating.value_for_money_rating);
					this.value_for_money_rate_pending = 5-this.value_for_money_rate;
					//  console.log(this.order_rate);
					console.log(this.reviews);
            } else {
               this.$swal("", "Something went wrong", "error");
            }
         })
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                     
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                     
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
		},

		productDetails(p_id){
			this.i =1;
			this.total_price_show='';
			this.total_price='';
			this.price='';
			const config = {
            headers: {
               "Content-type": "multipart/form-data",
               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,

            },
         };
         let url = "products/details";          
			let formData = new FormData(); 
         formData.append("product_id", p_id);
			formData.append("uid", this.uid);
         formData.append("device_token", this.device_token);

         this.$axios
         .post(url,formData, config)
         .then((res) => {
	         if(res.status == 200) {
	            var responseData = res.data.data;
	            console.log(responseData);
					this.res_product = responseData;
					this.ovalues = []; 
					
	            console.log(this.res_product);
					//document.getElementById('details').scrollIntoView({behavior:'smooth'});
					this.$refs.details.scrollIntoView({behavior:'smooth'});
	         } else {
	            this.$swal("", "Something went wrong", "error");
	         }
                  
         })
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                        
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

              } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                        
               } else {
                        this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
		},

		addFavorite(p_id,status,id){
			const config = {
            headers: {
               "Content-type": "multipart/form-data",
               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
         };

         let url = "favourites/add";          
			let formData = new FormData(); 
         formData.append("product_id", p_id);
			formData.append("uid", this.uid);
         formData.append("branch_id",this.$route.params.branch_id);
         formData.append("restaurant_id", this.$route.params.id );

         this.$axios
         .post(url,formData, config)
         .then((res) => {
            if(res.status == 200) {
               this.$swal("", res.data.message, "success");
					if(status==1) {
						if(id){
							console.log(id);       
							// this.$router.push({ name: "restaurant-details" });
							this.fetchRestaurant();	
							document.getElementById('category-tab'+id).scrollIntoView({behavior:'smooth'});
						} else{
						this.fetchRestaurant();	
						document.getElementById('category-tab0').scrollIntoView({behavior:'smooth'});
						}

					} else {
						this.productDetails(p_id);	
					}
            } else {
               this.$swal("", "Something went wrong", "error");
					console.log(this.error);
            }
                  
         })
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                        
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                        
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
		},

		removeFavorite(favourite_id,status,p_id,id){
			const config = {
            headers: {
               "Content-type": "multipart/form-data",
               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
         };

         let url = "favourites/remove";          
			let formData = new FormData(); 
         formData.append("favourite_id", favourite_id);
			formData.append("uid", this.uid);

         this.$axios
         .post(url,formData, config)
         .then((res) => {
            if(res.status == 200) {
	            this.$swal("", res.data.message, "success");        
					document.getElementById('details').scrollIntoView({behavior:'smooth'});

					if(status==1) {
						if(id){
							console.log('id');       
							this.fetchRestaurant();	
							document.getElementById('category-tab'+id).scrollIntoView({behavior:'smooth'});
						} else {
							this.fetchRestaurant();	
							document.getElementById('category-tab0').scrollIntoView({behavior:'smooth'});
						}
					} else {
						console.log(p_id);  
						this.productDetails(p_id);	
						document.getElementById('details').scrollIntoView({behavior:'smooth'});
					}
         	} else {
                  this.$swal("", "Something went wrong", "error");
						console.log(this.error);
            }
         })
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                        
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                        
              } else {
                  this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", error.message, "error");
                  }
               })
               .finally(() => (this.loading = false));
		},
		searchFoods(){
			const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

         let url = "products/search";          
			let formData = new FormData(); 
         formData.append("device_token", "");
			formData.append("uid", this.uid);
			formData.append("restaurant_id",this.$route.params.id );
			formData.append("key", this.key);

         this.$axios
         .post(url,formData, config)
         .then((res) => {
            if(res.status == 200) {
					this.searchs = res.data.data;
					this.search_visible = true;
					console.log(this.searchs);
					this.$swal("", res.data.message, "success");        
					// document.getElementById('details').scrollIntoView({behavior:'smooth'});

            } else {
               this.$swal("", "Something went wrong", "error");
					console.log(this.error);
            }
                  
         })
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                        
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                        
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
		},

		setSearchProduct(){
			this.res_product_id = event.target.options[event.target.options.selectedIndex].value;
			console.log(this.res_product_id);
         this.search_visible = false;
			this.productDetails(this.res_product_id);
		},

		show(){
			this.show_visible = true;
		},

		Notshow(){
			this.show_visible = false;
		},

		incrementCartItem(){
			this.i = this.i + 1;
			this.setPrice();
			document.getElementById('details').scrollIntoView({behavior:'smooth'});
		},

		decrementCartItem(){
			if(this.i>1){
				this.i = this.i - 1;
				this.setPrice();
				document.getElementById('details').scrollIntoView({behavior:'smooth'});
			}
		},

		addCart(){

			var getboxchoices = [];
			getboxchoices = this.checkbox_values;
			console.log(getboxchoices);
			getboxchoices.forEach(obj => {
			obj = obj.split("_");
			console.log(obj);
			this.arranged_choices.push({pchoice_id: obj[0], pcat_id: obj[1], product_id: obj[2], name: obj[3],  price: obj[4], status: obj[5], timestamp: obj[6]});
			});

			var getradiochoices = [];
			getradiochoices = this.ovalues;
			console.log(getradiochoices);
			getradiochoices.forEach(obj1 => {
			 	obj1 = obj1.split("_");
			 	console.log(obj1);
			 	this.arranged_choices.push({pchoice_id: obj1[0], pcat_id: obj1[1], product_id: obj1[2], name: obj1[3],  price: obj1[4], status: obj1[5], timestamp: obj1[6]});
			});
		
			console.log(this.arranged_choices);
			console.log(this.res_product.p_id);

			var price = 0;
			if(this.inputs.price_id) {
				price = this.inputs.price_id;
			} else {
				if(this.res_product.prices.length == 1) {
					price = this.res_product.prices[0].price;
				} 
			}

			this.size_unfilled = false;
			if(!price) {
				this.size_unfilled = true;
			}
	
			
			this.choice_errors = [];
			this.choice_unfilled = false;
			this.res_product.choices.forEach(choice => {
				var temp = {};
				temp.pcat_id = choice.pcat_id;
				temp.required = choice.required;
				temp.required_error = false;
				if(parseInt(choice.required) == 1) {
					var found = this.arranged_choices.some(el => el.pcat_id === choice.pcat_id);
					if(!found) {
						temp.required_error = true;
						this.choice_unfilled = true;
					}
				}
				this.choice_errors.push(temp);
			});

			console.log(this.choice_errors);

			if(!this.size_unfilled && !this.choice_unfilled) {

				if(this.user_id){
					const config = {
						headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
						},
	            };
	            let url = "cart/add";          
				   let formData = new FormData(); 
	         
				   formData.append("product_id", this.res_product.p_id);			   
						formData.append("price_id", price);
				   
				   formData.append("quantity", this.i);
				   formData.append("branch_id", this.branch_id);
				   formData.append("device_token", this.device_token);
				   formData.append("uid", this.uid);
				   formData.append("special_request", this.notes);
				   formData.append('choice_values', JSON.stringify(this.arranged_choices));

	            this.$axios
	            .post(url,formData, config)
	            .then((res) => {
						if(res.status == 200) {
							console.log(res);
							if(res.data.status == true){
								this.$swal("", res.data.message, "success"); 
								//this.$router.push({ name: "cart" });  
								this.$router.go();      
							} else {
								//this.toast=1;
								this.$bvModal.msgBoxConfirm('Your existing cart will be cleared. Are you sure you want to start a new cart?', {
			                  title: 'Confirm',
			                  size: 'sm',
			                  buttonSize: 'sm',
			                  okVariant: 'danger',
			                  okTitle: 'Yes',
			                  cancelTitle: 'No',
			                  footerClass: 'p-2',
			                  hideHeaderClose: false,
			                  centered: true
				            })
				            .then(value => {
				               if(value){
				                  this.clearcart()
				               }
				            })
				            .catch(err => {
				               console.log(err);
				            })
							}
	       
						} else {
							this.$swal("", "Something went wrong", "error");
							console.log(this.error);
						}
	            })
	            .catch((error) => {
	               if (error.response) {
	                  if(error.response.status == 422) {               
	                     if (error.response.data) {
	                        this.errors = error.response.data.message;
	                     } 
	                     this.$swal("", error.response.statusText, "error");
	                        
	                  } else if(error.response.status == 500) {
	                     this.$swal("", error.response.statusText, "error");

	                  } else if(error.response.status == 401) {
	                     this.$swal("", error.response.statusText, "error");
	                     this.$router.push({ name: "login" });
	                        
	                  } else {
	                     this.$swal("", "Something went wrong", "error");
	                  }
	               } else {
	                  this.$swal("", error.message, "error");
	               }
	            })
	            .finally(() => (this.loading = false));

				} else if(this.guest_id){
					const config = {
						headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
						},
	            };

	            let url = "guest/addCart";          
				   let formData = new FormData(); 
				   formData.append("product_id", this.res_product.p_id);

				
					formData.append("price_id", price);
				
				   formData.append("quantity", this.i);
				   formData.append("branch_id", this.branch_id);
				   formData.append("special_request", this.notes);
				   formData.append('choice_values', JSON.stringify(this.arranged_choices));

	            this.$axios
	            .post(url,formData, config)
	            .then((res) => {
	               if(res.status == 200) {
							if(res.data.status == true){
								this.$swal("", res.data.message, "success"); 
								this.$router.go(); 
								//this.$router.push({ name: "cart" });       
							} else {
								//this.toast=1;
								this.$bvModal.msgBoxConfirm('Your existing cart will be cleared. Are you sure you want to start a new cart?', {
			                  title: 'Confirm',
			                  size: 'sm',
			                  buttonSize: 'sm',
			                  okVariant: 'danger',
			                  okTitle: 'Yes',
			                  cancelTitle: 'No',
			                  footerClass: 'p-2',
			                  hideHeaderClose: false,
			                  centered: true
				            })
				            .then(value => {
				               if(value){
				                  this.clearcart()
				               }
				            })
				            .catch(err => {
				               console.log(err);
				            })
							}  

							//this.$router.go().catch(()=>{}); 
							//this.$router.push({ name: "restaurant-details", params: {id: this.$route.params.id ,branch_id: this.$route.params.branch_id } }).catch(()=>{}); 

	               } else {
	                  this.$swal("", "Something went wrong", "error");
							console.log(this.error);
	               }
	            })
	            .catch((error) => {
	               if (error.response) {
	                  if(error.response.status == 422) {               
	                     if (error.response.data) {
	                        this.errors = error.response.data.message;
	                     } 
	                     this.$swal("", error.response.statusText, "error");
	                        
	                     } else if(error.response.status == 500) {
	                        this.$swal("", error.response.statusText, "error");

	                     } else if(error.response.status == 401) {
	                        this.$swal("", error.response.statusText, "error");
	                        this.$router.push({ name: "login" });
	                        
	                     } else {
	                        this.$swal("", "Something went wrong", "error");
	                     }
	                  } else {
	                     this.$swal("", error.message, "error");
	                  }
	                })
	               .finally(() => (this.loading = false));
				} else {
					this.$router.push({ name: "login" });
				}
			}
		},
		setPrice(){
			
			this.arranged_choice_prices=[];
			var getboxchoiceprices = [];
			
			if(this.inputs.price_id){
				this.price = this.inputs.price_id;
			} else {
				if(this.res_product.prices.length == 1) {
					this.price = this.res_product.prices[0].price;
				} else {
					this.price = 0;
				}
			}
			getboxchoiceprices = this.checkbox_values;
			console.log(getboxchoiceprices);
			getboxchoiceprices.forEach(obj => {
			 obj = obj.split("_");
			 this.arranged_choice_prices.push(obj[4]);
			});

			var getradiochoiceprices = [];
			getradiochoiceprices = this.ovalues;
			console.log(getradiochoiceprices);
			getradiochoiceprices.forEach(obj1 => {
			 obj1 = obj1.split("_");
			 this.arranged_choice_prices.push(obj1[4]);
			});

			console.log(this.arranged_choice_prices);
			let basket_total = 0;
			this.arranged_choice_prices.forEach(val => {
				basket_total += Number(val);
			});
			console.log(basket_total);

			this.total_price = this.i*this.price;
			console.log(this.total_price);

			this.total_price_show = this.total_price +this.i*basket_total;
			console.log(this.total_price_show);

			// document.getElementById('details').scrollIntoView({behavior:'smooth'});
		},
		clearcart(){
				
				// this.getToken();
				if(this.uid){
					let url = "cart/delete?uid="+this.uid+"&device_token=";
						console.log(this.token);
						this.loading = true;
						
						this.$axios
						.get(url, { headers: { Authorization:"Bearer " +this.token } })
						.then((res) => {
							console.log(res);
							if(res.status == 200) {
								var responseData1 = res.data;
								console.log(responseData1);
								//this.toast=0;
								this.$router.go().catch(()=>{}); 
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						})
						.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
									this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");
			
							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
						})
						.finally(() => (this.loading = false));
				}else if(this.guest_id){
					let url = "guest/delete";
						
						this.loading = true;
						
						this.$axios
						.get(url, { headers: { Authorization:"Bearer " +this.token } })
						.then((res) => {
							console.log(res);
							if(res.status == 200) {
								var responseData1 = res.data;
								console.log(responseData1);
								//this.toast=0;
								this.$router.go().catch(()=>{}); 
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						})
						.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
									this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");
			
							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
						})
						.finally(() => (this.loading = false));
				}
				
			},

			infoMouseOver() {
        		this.$refs.infodropdown.visible = true;
      	},
      	infoMouseLeave() {
        		this.$refs.infodropdown.visible = false;
      	},
		
		}
}
</script>

<template>
	<Layout>
		<!--Carousel-->
		<div class="carousel slide container-expand-sm" data-bs-ride="false">
			<div class="carousel-inner">
				<div class="carousel-item active" imgbox>
					<!-- <img src="/design/sigofood-images/Dairy-queen.png" alt="Dairy Queen" class="slide d-block w-100 "> -->
					<img v-if="restaurant.rest_image" :src="$image_url + restaurant.rest_image" alt  class="slide d-block w-100" style="height:400px; width:548px;" >
               <img v-else src="/design/sigofood-images/Dairy-queen.png" alt  class="slide d-block w-100 " />
				</div>
			</div>
		</div>

		<!--Description-->

		<div class="container-expand-sm dairyqueen"  style="background-color: rgb(245, 244, 244);">
			<div class="container-sm">
				<div class="container">
					<div class="row">
						<div class="col">
							<h4 class="restaurant-name">{{restaurant.rest_name}}</h4>
						</div>
						<div class="col-1">
							<img class="" src="/design/sigofood-images/share-black.png" style="height: 20px;">
						</div>
						<div class="col-1" style="position:static;">
							
							<div class="info-wrapper"  @mouseover="infoMouseOver" @mouseleave="infoMouseLeave">
								<b-dropdown ref="infodropdown" right variant="link" toggle-class="text-decoration-none" no-caret>
									<template #button-content>
							      	<i class="material-icons">info</i>
							   	</template>								
    								<b-dropdown-item>
										<div class="restaurant-info">	
											<h3 class="rest_name">{{restaurant.rest_name}}</h3>							
											<p class="type_name">{{restaurant.types[0].name}}</p>
											<p class="text" v-if="restaurant.types">{{restaurant.types.name}}</p>
											<div class="rest-inner">	
												<div>
													<div v-if="rating.total_ratings > 4 ">								
														<img src="/design/sigofood-images/smile5.png" style="height: 20px;"> Amazing based on 4 ratings 
													</div>
													<div v-else-if="rating.total_ratings > 3 ">
														<img src="/design/sigofood-images/smile4.png" style="height: 20px;"> Very Good based on 4 ratings
														<p></p>
													</div>
													<div v-else-if="rating.total_ratings > 2 ">
														<img src="/design/sigofood-images/smile3.png" style="height: 20px;"> Good based on 4 ratings
													</div>
													<div v-else-if="rating.total_ratings > 1 ">
														<img src="/design/sigofood-images/smile22.png" style="height: 20px;"> Ok based on 4 ratings
													</div>
													<div v-else>
														<img src="/design/sigofood-images/smile1.png" style="height: 20px;"> Bad based on 4 ratings
													</div>
												</div>

												<table align="center">
													<tr>
														<th style="text-align: left;">Restaurant Area </th>
														<td>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</td>
														<th colspan="3" style="text-align: right;">{{restaurant.city}}</th>
													</tr>
													<tr> 
													
														<th style="text-align: left;">Opening Hours</th>
														<td>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</td>
														<th colspan="2" style="text-align: right;">{{restaurant.open_time}} - {{restaurant.close_time}}</th>
													</tr>
													<tr> 
													
														<th style="text-align: left;">Delivery Time </th>
														<td>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</td>
														<th colspan="2" style="text-align: right;">{{restaurant.delivery_time}} mins</th>
													</tr>
													<tr> 
														
														<th style="text-align: left;">Minimum Order</th>
														<td>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</td>
														<th colspan="2" style="text-align: right;">{{restaurant.min_order}}</th>
													</tr>
													<tr> 
														
														<th style="text-align: left;">Delivery Fee</th>
														<td>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</td>
														<th colspan="2" style="text-align: right;">BHD {{restaurant.delivery_fee}}</th>
													</tr>
												</table>
											
											</div>
										</div><!-- end of .restaurant-info -->	
									</b-dropdown-item>
								</b-dropdown>	
							</div>	
						</div>
						
					</div>
					
					<p  class="text-muted">
						<span v-for = "(type,index) in types"  :key="type.name">{{type.name}}
						<span v-if="index < types.length-1">, </span> </span>
					</p>					

					<div class="row pb-3">
						<div class="col features">
							<div class="column">
								<div class="col">
									<h6 class="text-center">{{restaurant.reviews}}</h6>
								</div>
								<div class="col">
									<p class="text-muted text-center">Rating & Reviews</p>
								</div>
							</div>
						</div>
						<div class="col features">
							<div class="column">
								<div class="col">
									<h6 class="text-center">BHD {{restaurant.delivery_fee}}</h6>
								</div>
								<div class="col">
									<p class="text-muted text-center">Delivery Fee</p>
								</div>
							</div>

						</div>
						<div class="col features">
							<div class="column">
								<div class="col">
									<h6 class="text-center">{{restaurant.delivery_time}} min</h6>
								</div>
								<div class="col">
									<p class="text-muted text-center">Delivery Time</p>
								</div>
							</div>
						</div>
						<div class="col features">
							<div class="column">
								<div class="col">
									<h6 class="text-center">{{restaurant.min_order}}</h6>
								</div>
								<div class="col">
									<p class="text-muted text-center">Min Order</p>
								</div>
							</div>
						</div>
					</div>
				</div>				
			</div>
		</div>


		<!--Search-->
		<div class="container-sm ">			
			<b-input-group class="mt-3 search">
    			<b-form-input placeholder="Search Foods" class="form-control" v-model="key" @keyup="searchFoods()"></b-form-input>
    			<b-input-group-append>
      			<b-button variant="outline-warning"><i class="material-icons">search</i></b-button>
    			</b-input-group-append>

    			<b-form-select class="form-control" v-if="search_visible && Boolean(searchs.length)" v-model="search_product_id" :select-size="searchs.length < 10 ? (searchs.length <= 1 ? 2 : searchs.length) : 10" @change="setSearchProduct()">
                    <b-form-select-option v-for="search_product in searchs" :key="search_product.p_id" :value="search_product.p_id">{{search_product.name}} </b-form-select-option>
                </b-form-select>
				<b-form-select class="form-control" v-if="search_visible && !Boolean(searchs.length)" v-model="search_product_id" :select-size="2">                  
                <b-form-select-option :value="0" disabled>No results...</b-form-select-option>
                </b-form-select>
  			</b-input-group>
		</div>

		<!--Menu-->

		<div class="container-sm mt-3">
			<div class="col-xl-12">
				<div class="row">
					<div class="col-2">
						<img src="/design/sigofood-images/menu.png" style="height: 30px; width: 35px;">
					</div>
					<div class="col">
						<div id="exTab1" >
							<ul class="nav nav-pills nav-fill" id="category-tab">
								<li class="nav-item" style="min-width: 100px;" >
									<button class="nav-link most_selling tab1 active" data-bs-target="#category-tab0" data-id="0" data-bs-toggle="tab"  v-if="Boolean(best_selling.length)" >Most Selling</button>
								</li>
							
									<li class="nav-item"  v-for = "(category,index) in categories"  :key="index" style="min-width: 200px;">
										<button class="nav-link tab2" :data-id="index+1" v-if="category.products.length" :data-bs-target="'#category-tab'+(index+1)" data-bs-toggle="tab">{{category.name}}</button>
								</li>	
							</ul><br>

						</div>
					</div>
				</div>   
			</div>
			<div class="row">
				<div class="col-xl-6 col-lg-7">
					<div class="tab-content ">
						<div class="tab-pane show active" id="category-tab0" v-if="Boolean(best_selling.length)">
							<h3 class="category-name">Most Selling</h3>
							<div class="card mb-3 category-product" v-for="(best_product) in best_selling" :key="best_product.name">
								<div class="row g-0" @click="productDetails(best_product.p_id)">
									<div class="col-md-3 imgbox">
										<div v-if="best_product.thumbnail" :style="{ 'background-image': 'url(' + $image_url + best_product.thumbnail + ')' }" @click="productDetails(best_product.p_id)"></div>
										<div v-else :style="{ backgroundImage: `url(${NoImageUrl})` }"></div>
										<!-- <a href="#details"> -->
											<!-- <img :src="$image_url + best_product.thumbnail" alt class="img-fluid rounded-start" @click="productDetails(best_product.p_id)"> -->
										<!-- </a> -->

									</div>
									<div class="col-md-9">
										<div class="card-body">
											<div class="row">
												<div class="col">
													<h5 class="card-title product-name">{{best_product.name}}</h5>
												</div>
													<div class="col-3 col-md-2 d-flex">
														<img src="/design/sigofood-images/share.png" alt="share" style="height:18px; width:18px; margin-right: 10px;">
														<!-- </div> -->
														<div  v-if="uid">
															<img src="/design/sigofood-images/favorite.png" v-if="best_product.fav_status==true" @click="removeFavorite(best_product.fav_id,'1',best_product.p-id)" alt="share"
															style="height:18px; width:18px;">
															<img src="/design/sigofood-images/favorite-outline.png" v-else alt="share"
															style="height:18px; width:18px;" @click="addFavorite(best_product.p_id,'1')">
														</div>
													</div>
														<!-- <div class="col-2 d-flex" v-else>
															<img src="/design/sigofood-images/favorite-outline.png" alt="share"
															style="height:18px; width:18px;" @click="addFavorite(best_product.p_id,'1')">
														</div> -->
												
											</div>

											<p class="card-text"><small class="text-muted">{{best_product.description | excerpt(30)}}</small></p>
											<button class="price" v-if="best_product.size=='multi'">Price on selection</button>
											<button class="price" v-else >BHD {{best_product.price}}</button>

										</div>
									</div>
								</div>
							</div>

						</div>
						<!-- <div > -->
							<div class="tab-pane" :id= "'category-tab'+(index+1)" v-for = "(category,index) in categories"  :key="index">
								<h3 class="category-name">{{category.name}}</h3>
								<!-- <div v-for = "(product) in category.products"  :key="product.name"> -->
									<div class="card mb-3 category-product" v-for = "(product) in category.products"  :key="product.name">
										<div class="row g-0">
											<div class="col-md-3 imgbox">
												<!-- <img :src="$image_url + product.thumbnail" alt
													class="img-fluid rounded-start" @click="productDetails(product.p_id)"> -->
												<div v-if="product.thumbnail" :style="{ 'background-image': 'url(' + $image_url + product.thumbnail + ')' }" @click="productDetails(product.p_id)"></div>
												<div v-else :style="{ backgroundImage: `url(${NoImageUrl})` }" @click="productDetails(best_product.p_id)"></div>
											</div>
											<div class="col-md-9">
												<div class="card-body">
													<div class="row">
														<div class="col">
															<h5 class="card-title product-name">{{product.name}}</h5>
														</div>
														<div class="col-2 d-flex">
															<img src="/design/sigofood-images/share.png" alt="share"
															style="height:18px; width:18px;">
														</div>
														<div class="col-2 d-flex" v-if="uid">
															<img src="/design/sigofood-images/favorite.png" v-if="product.fav_status==true"  @click="removeFavorite(product.fav_id,'1',product.p_id,(index+1))" alt="share"
															style="height:18px; width:18px;">
															<img src="/design/sigofood-images/favorite-outline.png" v-else @click="addFavorite(product.p_id,'1',(index+1))" alt="share"
															style="height:18px; width:18px;">
														</div>
												<!-- <div class="col-2 d-flex" v-else>
													<img src="/design/sigofood-images/favorite-outline.png" @click="addFavorite(product.p_id,'1',(index+1))" alt="share"
													style="height:18px; width:18px;">
												</div> -->
													</div>

													<p class="card-text"><small class="text-muted">{{product.description  | excerpt(30)}}</small></p>
													<!-- <button class="price">BHD {{product.price}}</button> -->
													<button class="price" v-if="product.size=='multi'">Price on selection</button>
													<button class="price" v-else >BHD {{product.price}}</button>

												</div>
											</div>
										</div>
									</div>
							</div>
					</div>
				</div>
				<!--Rating and Reviews-->
				<div class="col-xl-6 col-lg-5">
					<div class="card ratings-reviews">
							<!--Rating and Reviews commented-->
						<div class="card-body">
							<h5 class="mx-auto text-center ratings-title">Rating & Reviews</h5><br>
							<div class="row">
								<div class="col-5  smile" v-if="rating.total_ratings > 4 ">
									<img src="/design/sigofood-images/smile5.png" style="height: 35px;">
								</div>
								<div class="col-5  smile" v-else-if="rating.total_ratings > 3 ">
									<img src="/design/sigofood-images/smile4.png" style="height: 35px;">
								</div>
								<div class="col-5  smile" v-else-if="rating.total_ratings > 2 ">
									<img src="/design/sigofood-images/smile3.png" style="height: 35px;">
								</div>
								<div class="col-5  smile" v-else-if="rating.total_ratings > 1 ">
									<img src="/design/sigofood-images/smile22.png" style="height: 35px;">
								</div>
								<div class="col-5  smile" v-else>
									<img src="/design/sigofood-images/smile1.png" style="height: 35px;">
								</div>
								<div class="col" v-if="rating.total_ratings > 4 ">
									<div><h5>Amazing</h5></div>
									<div><p><small class="text-muted">Based on 4 reviews</small></p></div>
								</div>
								<div class="col" v-else-if="rating.total_ratings > 3 ">
									<div><h5>Very Good</h5></div>
									<div><p><small class="text-muted">Based on 4 reviews</small></p></div>
								</div>
								<div class="col" v-else-if="rating.total_ratings > 2 ">
									<div><h5>Good</h5></div>
									<div><p><small class="text-muted">Based on 4 reviews</small></p></div>
								</div>
								<div class="col" v-else-if="rating.total_ratings > 1 ">
									<div><h5>Ok</h5></div>
									<div><p><small class="text-muted">Based on 4 reviews</small></p></div>
								</div>
								<div class="col" v-else>
									<div><h5>Bad</h5></div>
									<div><p><small class="text-muted">Based on 4 reviews</small></p></div>
								</div>
							</div>
							<div class="overall-rating">
								<div class="row">
									<div class="col-4 col-lg-4">
										<p>Order Packaging</p>
									</div>

									<div class="col-5 col-lg-6">
										<ul class="d-flex stars" >
											<li class="mx-auto text-center" v-for="n in order_rate" :key="n" ><img src="/design/sigofood-images/star1.png"></li>
											<li class="mx-auto text-center" v-for="j in order_rate_pending" :key="j" ><img src="/design/sigofood-images/star2.png"></li> 
										</ul>
									</div>
									<div class="col-3 col-lg-2 specific-rating">
										<p>{{rating.order_pacaking_rating}}</p>
									</div>
								</div>

								<div class="row">
									<div class="col-4 col-lg-4">
										<p>Value for money</p>
									</div>
									<div class="col-5 col-lg-6">
										<ul class="d-flex stars">
											<li class="mx-auto text-center" v-for="n in value_for_money_rate" :key="n" ><img src="/design/sigofood-images/star1.png"></li>
											<li class="mx-auto text-center" v-for="j in value_for_money_rate_pending" :key="j" ><img src="/design/sigofood-images/star2.png"></li> 
											
										</ul>
									</div>
									<div class="col-3 col-lg-2 specific-rating">
										<p>{{rating.value_for_money_rating}}</p>
									</div>
								</div>

								<div class="row">
									<div class="col-4 col-lg-4">
										<p>Delivery Time</p>
									</div>
									<div class="col-5 col-lg-6">
										<ul class="d-flex stars">
										
											<li class="mx-auto text-center" v-for="n in delivery_time_rate" :key="n" ><img src="/design/sigofood-images/star1.png"></li>
											<li class="mx-auto text-center" v-for="j in delivery_time_rate_pending" :key="j" ><img src="/design/sigofood-images/star2.png"></li> 
										</ul>
									</div>
									<div class="col-3 col-lg-2 specific-rating">
										<p>{{rating.delivery_time_rating}}</p>
									</div>
								</div>

								<div class="row">
									<div class="col-4 col-lg-4">
										<p>Quality of food</p>
									</div>
									<div class="col-5 col-lg-6">
										<ul class="d-flex stars">
											<li class="mx-auto text-center" v-for="n in food_quality_rate" :key="n" ><img src="/design/sigofood-images/star1.png"></li>
											<li class="mx-auto text-center" v-for="j in food_quality_rate_pending" :key="j" ><img src="/design/sigofood-images/star2.png"></li> 
											
										</ul>
									</div>
									<div class="col-3 col-lg-2 specific-rating">
										<p>{{rating.food_quality_rating}}</p>
									</div>
								</div>
							</div>
							<br>
							<div v-if="reviews.length">
								<div class="card mb-3 review-card"  v-for = "(review) in reviews"  :key="review.rr_id" >
									<div class="card-body">

										<div class="row">
											<div class="col-1 review-icon">											
												<img v-if="review.rating > 4 " src="/design/sigofood-images/smile5.png" style="height: 20px;">
												<img v-else-if="review.rating > 3 " src="/design/sigofood-images/smile4.png" style="height: 20px;">
												<img v-else-if="review.rating > 2 " src="/design/sigofood-images/smile3.png" style="height: 20px;">
												<img v-else-if="review.rating > 1 " src="/design/sigofood-images/smile2.png" style="height: 20px;">
												<img v-else src="/design/sigofood-images/smile1.png" style="height: 20px;">
											</div>
											<div class="col">
												<h6 v-if="review.rating > 4 ">Amazing</h6>
												<h6 v-else-if="review.rating > 3 ">Very Good</h6>
												<h6 v-else-if="review.rating > 2 ">Good</h6>
												<h6 v-else-if="review.rating > 1 ">OK</h6>
												<h6 v-else>Bad</h6>
											</div>											
										</div>
										<div class="row">
											<div class="col-12">
												<p class="card-title review1 mt-2">{{review.comments}}</p>
											</div>
											<div class="col">
												<p class="card-text"><small class="text-muted">-{{review.firstname}} {{review.lastname}}****</small></p>
											</div>
											<div class="col">
												<p class="card-text review-date"><small class="text-muted">{{review.date |formatDate}}</small></p>
											</div>
										</div>
									</div>
								</div>
							</div>
					</div>
					</div>
				</div>       
			</div>
		</div>

		<br>
		<span>
		<div class="container-sm details mb-5" id="details" ref="details">
			<div class="row p-3"  v-if="res_product">
				<div class="col-xl-6 ps-xl-5">
					<div class="card product-details">
						<div class="col-md-12 imgbox">
							<div v-if="res_product.thumbnail" :style="{ 'background-image': 'url(' + $image_url + res_product.thumbnail + ')' }"></div>
							<div v-else :style="{ backgroundImage: `url(${NoImageUrl})` }"></div>
						</div>							
						<div class="card-body">
							<div class="row">
								<h5 class="card-title">{{res_product.name}}</h5>
								<p class="card-text"><small class="text-muted">{{res_product.description}}</small></p>
								<div class="col">
									<button class="price">BHD {{res_product.prices[0].price | formatPrice}}</button>
								</div>
								<div class="col-1 d-flex">
									<img src="/design/sigofood-images/share.png" alt="share" style="height:18px; width:18px;">
								</div>
								<div class="col-2 d-flex" v-if="uid">
										<img src="/design/sigofood-images/favorite.png" v-if="res_product.favorite_id" alt="share" @click="removeFavorite(res_product.favorite_id,'2',res_product.p_id)"
													style="height:18px; width:18px;">
												
										<img src="/design/sigofood-images/favorite-outline.png" v-else @click="addFavorite(res_product.p_id,'2')" alt="share"
													style="height:18px; width:18px;">
								</div>
								</div>
						</div>
					</div> <!-- end of .product-details -->					

					<div class="accordion choice-accordion" role="tablist">
    					<b-card no-body class="mb-1" v-if="res_product.prices.length > 1">
      					<b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle.accordion-1  v-bind:class="size_unfilled ? 'choice-error': ''">
        						<p>Choose size <span class="choice">Required</span></p>
        						<i class="material-icons more">expand_more</i>
        						<i class="material-icons less">expand_less</i>
      					</b-card-header>
      					<b-collapse id="accordion-1" visible accordion="choice-accordion" role="tabpanel">
        						<b-card-body>
          						<b-form-radio-group>
										<div class="form-check ps-0" v-for="price in res_product.prices" :key="price.price_id">
										 	{{price.unit}} 
										 	<div class="float-end text-theme small">	BHD{{price.price | formatPrice}}
												<b-form-radio name="quantity_type" v-model="inputs.price_id" :value="price.price" @change="setPrice()" class="float-end ms-2"></b-form-radio>   
											</div>
										</div>
									</b-form-radio-group>
        						</b-card-body>
      					</b-collapse>
    					</b-card>

    					<b-card no-body class="mb-1" v-for="(choice,index) in res_product.choices" :key="choice.pcat_id">
      					<b-card-header header-tag="header" class="p-1" role="tab"  v-b-toggle="'accordion-choice-' + choice.pcat_id" v-bind:class="(choice_errors.length > 0  && choice_errors[index].pcat_id==choice.pcat_id && choice_errors[index].required_error==true) ? 'choice-error': ''">
        						<p style="text-transform: capitalize;">
        							<!-- <span v-if="choice.cat_type == 'remove'">No</span>
									<span v-else>{{choice.cat_type}}</span>
									&nbsp;{{choice.cat_name}} -->
									{{choice.cat_name}} ({{choice.cat_type}})
									<span class="choice" v-if="choice.required==1">Required</span>
									<span class="choice" v-else></span>
        						</p>
        						<i class="material-icons more">expand_more</i>
        						<i class="material-icons less">expand_less</i>
      					</b-card-header>
      					<b-collapse :id="'accordion-choice-' + choice.pcat_id" accordion="choice-accordion" role="tabpanel">
        						<b-card-body>
          						<b-col md="12" class="mb-4">
										<b-form-group class="attr-wrapper" v-if="choice.type==1" >
											<label>
												</label>

											<b-form-radio-group :name="'choice' + index" v-model="ovalues[index]" >

												<div class="form-check ps-0"  v-for="val in choice.choice_values" :key="val.pchoice_id">
										 			{{val.name}}
										 			<div class="float-end text-theme small">
														<span v-if="val.price != 0">BHD{{val.price | formatPrice}}</span>
														<b-form-radio :value="val.pchoice_id + '_' + val.pcat_id +'_' + val.product_id + '_' + val.name + '_' + val.price + '_' + val.status + '_' + val.timestamp"  @change="setPrice()" class="float-end ms-2">   </b-form-radio>
													</div>
												</div>	
											</b-form-radio-group>						
										</b-form-group>

										<b-form-group class="attr-wrapper" v-else >
											<b-form-checkbox-group  :name="'choice' + index" v-model="checkbox_values">

												<!-- <b-form-checkbox v-for="val in choice.choice_values" :key="val.pchoice_id" :value="val.pchoice_id + '_' + val.pcat_id +'_' + val.product_id + '_' + val.name + '_' + val.price + '_' + val.status + '_' + val.timestamp"  @change="setPrice()">{{val.name}}   <span v-if="val.price != 0">{{val.price}}</span></b-form-checkbox> -->

												<div class="form-check ps-0" v-for="val in choice.choice_values" :key="val.pchoice_id">
										 			{{val.name}}
										 			<div class="float-end text-theme small">
														<span v-if="val.price != 0">BHD{{val.price | formatPrice}}</span>														
														<b-form-checkbox :value="val.pchoice_id + '_' + val.pcat_id +'_' + val.product_id + '_' + val.name + '_' + val.price + '_' + val.status + '_' + val.timestamp"  @change="setPrice()" class="float-end ms-2"></b-form-checkbox>
													</div>
												</div>	

											</b-form-checkbox-group>
										</b-form-group>
									</b-col>
        						</b-card-body>
      					</b-collapse>
    					</b-card>
 					</div>
					
				</div>


				<div class="col-xl-6 details2  pe-xl-5">
					<div class="row">
						<b-col md="12" xl="12" class="form-group">
							<img src="/design/sigofood-images/notes.png">
							<label class="control-label ms-3 mb-3">Notes <span class="required">*</span></label>				
							<b-form-textarea rows="3" max-rows="6" v-model="notes" placeholder="Any special request, allergies...."></b-form-textarea>
						</b-col>
					</div>
					<br>
					<div class="col">
						<div id="outer">
							<div class="inner">
								<i class="material-icons" @click="decrementCartItem()">remove_circle</i>
							</div>
							<div class="inner"><h4>{{ i }}</h4></div>
							<div class="inner">
								<i class="material-icons" @click="incrementCartItem()">add_circle</i>
							</div>
						</div>
					</div>
					<br><br>

					<div class="add-cart-errors col-12">
						<p v-if="size_unfilled" class="">Please choose the size </p>
						<p v-if="choice_unfilled" class="">Please choose the required choices </p>
					</div>

					<div class="d-grid col-xl-12 mx-auto">
						<a class="btn checkout" role="button" href="javascript: void(0);"  @click="addCart()">
							<div class="row">
								<div class="col mx-auto text-start" v-if="total_price_show">
									<p class="mb-0">BHD{{parseFloat(total_price_show).toFixed(2)}}</p>
								</div>
								<div class="col mx-auto text-start" v-else>
									<p class="mb-0" v-if="res_product.prices.length == 1">BHD{{res_product.prices[0].price | formatPrice}}</p>
								</div>
								<div class="col mx-auto text-end">
									<p class="mb-0">Add to cart</p>
								</div>
							</div>
						</a>
					</div>

				</div>

		
			</div>

		</div>
		</span>

		
	</Layout>
</template>

